export const REQUEST_TRANSLATIONS: Record<string, string> = {
  'Аккаунт найден:': 'Account found:',
  'Аккаунт с таким email уже существует. Введите пароль — заявка не потеряется.': 'An account with this email already exists. Enter your password and the request will be preserved.',
  'Более 2 недель': 'More than 2 weeks',
  'Бюджет': 'Budget',
  'В ближайшие 2 дня': 'Within the next 2 days',
  'В течение недели': 'Within a week',
  'Введите два города или выберите популярное направление одним кликом': 'Enter two cities or choose a popular route',
  'Введите корректный номер телефона': 'Enter a valid phone number',
  'Введите номер телефона.': 'Enter a phone number.',
  'Введите пароль': 'Enter password',
  'Вес': 'Weight',
  'Вес, кг': 'Weight, kg',
  'Ветпаспорт и прививки': 'Pet passport and vaccinations',
  'Возраст': 'Age',
  'Войдите, чтобы сохранить заявку': 'Log in to save your request',
  'Войти и продолжить': 'Log in and continue',
  'Всё верно — публикуем?': 'Everything looks right. Publish?',
  'Все документы есть': 'All documents are ready',
  'Готов оплатить': 'I am ready to pay',
  'Готово! Заявка опубликована': 'Done! Your request is live',
  'Готовы': 'Ready',
  'Дальше': 'Continue',
  'Дам корм с собой': 'I will provide food',
  'Дата доставки не может быть раньше даты забора.': 'The delivery date cannot be earlier than the pickup date.',
  'Дата забора не может быть в прошлом.': 'The pickup date cannot be in the past.',
  'Диапазон': 'Range',
  'Для публикации нужен профиль заказчика.': 'A customer profile is required to publish a request.',
  'Для этого размера экрана в Figma отсутствует утверждённый макет': 'There is no approved Figma layout for this screen size',
  'До, ₽': 'To, ₽',
  'Документы оформляются': 'Documents are being prepared',
  'Доставить не позже': 'Deliver no later than',
  'Доставка': 'Delivery',
  'Другое': 'Other',
  'Если выбрали «Другое», опишите вид': 'If you selected “Other”, describe the animal',
  'Если у вас уже есть аккаунт — попросим пароль. Если нет — за минуту создадим новый, заявка не потеряется.': 'If you already have an account, we will ask for your password. Otherwise, you can create one in a minute and the request will be preserved.',
  'Забор': 'Pickup',
  'Забрать не раньше': 'Pick up no earlier than',
  'Завершение': 'Finish',
  'Изменить email': 'Change email',
  'К моим заявкам': 'Go to my requests',
  'Кличка (опционально)': 'Pet name (optional)',
  'Когда нужно ехать?': 'When should the trip take place?',
  'Кого везём?': 'Who is travelling?',
  'Количество': 'Number of pets',
  'Контактное лицо': 'Contact person',
  'Контакты': 'Contacts',
  'Кормит перевозчик': 'Carrier provides food',
  'Кормление в пути': 'Feeding during the trip',
  'Кто встретит и передаст': 'Pickup and delivery contacts',
  'Маршрут': 'Route',
  'Можно загрузить не более 8 фото.': 'You can upload up to 8 photos.',
  'Можно задать ориентир — или оставить пусто, и перевозчики предложат свои цены': 'Set an estimated budget or leave it blank and let carriers quote their prices',
  'Можно подождать': 'I can wait',
  'Например, лабрадор': 'For example, Labrador',
  'Например, Питомник «Бэст»': 'For example, Best Kennel',
  'Например, черепаха красноухая': 'For example, red-eared slider',
  'Например: боится громких звуков, есть аллергия на курицу, требует прогулок каждые 4 часа...': 'For example: afraid of loud noises, allergic to chicken, needs a walk every 4 hours…',
  'Например: район Адлера, ближе к набережной.': 'For example: Adler district, near the seafront.',
  'Например: район Тверская, ближе к метро Маяковская. Удобнее после 10 утра.': 'For example: Tverskaya district, near Mayakovskaya station. After 10 a.m. is preferred.',
  'Не удалось сохранить фото. Попробуйте выбрать файл ещё раз.': 'Could not save the photo. Please select the file again.',
  'Не указан': 'Not specified',
  'Не пришёл код? Отправить снова через 0:42': 'No code? Send again in 0:42',
  'Номер заявки': 'Request number',
  'Нужна от перевозчика': 'Needed from the carrier',
  'Нужна помощь': 'Need help',
  'Обычная': 'Standard',
  'Опишите вид животного.': 'Describe the animal.',
  'Опубликовать и получить отклики': 'Publish and receive offers',
  'Ориентир по району (опционально)': 'Area details (optional)',
  'Особенности животного': 'Pet details',
  'От, ₽': 'From, ₽',
  'Открыта · ждём отклики': 'Open · waiting for offers',
  'Открыть заявку': 'Open request',
  'Откуда и куда поедет питомец?': 'Where is your pet travelling from and to?',
  'Оформляются': 'Being prepared',
  'Перевозчик узнает животное при встрече и пришлёт фото в пути — будет с чем сравнить': 'The carrier will recognise your pet at pickup and send journey photos for comparison',
  'Перевозчики уже видят её в общей ленте. Первые отклики обычно приходят в течение часа — придёт уведомление.': 'Carriers can now see it in the feed. The first offers usually arrive within an hour, and we will notify you.',
  'Переноска': 'Pet carrier',
  'Переноска / клетка': 'Carrier / crate',
  'Переноска, документы, привычки питомца — мелочи, на которых строится спокойная поездка': 'Carrier, documents and habits are the details that make a calm journey possible',
  'Перетащите фото или нажмите, чтобы загрузить': 'Drag photos here or click to upload',
  'Питомник, приют, зооклиника или другая организация.': 'Kennel, shelter, veterinary clinic or another organisation.',
  'Повторить публикацию заявки': 'Try publishing again',
  'Поддерживаются JPG, PNG и WEBP.': 'JPG, PNG and WEBP are supported.',
  'Покажите питомца': 'Show us your pet',
  'Получатель': 'Recipient',
  'Получите более точные отклики': 'Receive more accurate offers',
  'Популярные направления': 'Popular routes',
  'Порода': 'Breed',
  'Предложат перевозчики': 'Let carriers quote',
  'Прививки актуальны': 'Vaccinations are up to date',
  'Проверьте детали, любой блок можно поправить — кнопка «Изменить» рядом с каждым': 'Review the details. You can edit any section using the “Edit” button next to it.',
  'Пропустить': 'Skip',
  'Публикуем…': 'Publishing…',
  'Пусть предложат': 'Let carriers quote',
  'Размер одного фото не должен превышать 10 МБ.': 'Each photo must be no larger than 10 MB.',
  'Рекомендуем давать корм с собой — питомцу не придётся адаптироваться к новой еде в стрессовой поездке.': 'We recommend providing food so your pet does not have to adjust to a new diet during a stressful journey.',
  'Своя': 'I have one',
  'Своя переноска': 'Own carrier',
  'Сельхоз': 'Farm animal',
  'Сколько готовы заплатить?': 'What is your budget?',
  'Собака · лабрадор': 'Dog · Labrador',
  'Сохранить и опубликовать заявку': 'Save and publish request',
  'Сохраним заявку — введите email': 'Enter your email to save the request',
  'Сравните цены': 'Compare prices',
  'Сроки': 'Dates',
  'Срочная': 'Urgent',
  'Срочность': 'Urgency',
  'Статус': 'Status',
  'Телефон получателя': 'Recipient phone',
  'Тип': 'Type',
  'Тип животного': 'Animal type',
  'Тип животного, порода и основные параметры — это поможет перевозчику подготовиться.': 'Animal type, breed and key details will help the carrier prepare.',
  'Точный адрес скажете перевозчику в чате после выбора — здесь только контакты и ориентир по району. Так безопаснее.': 'Share the exact address with the selected carrier in chat. Only contact and area details are shown here for safety.',
  'У меня есть': 'I have one',
  'У этого аккаунта нет профиля заказчика.': 'This account has no customer profile.',
  'Укажите ваше имя.': 'Enter your name.',
  'Укажите даты забора и доставки.': 'Enter pickup and delivery dates.',
  'Укажите контактное лицо': 'Enter a contact person',
  'Укажите оба города маршрута.': 'Enter both route cities.',
  'Укажите организацию и контактное лицо.': 'Enter the organisation and contact person.',
  'Укажите ориентир бюджета или выберите предложения перевозчиков.': 'Enter an estimated budget or choose carrier quotes.',
  'Укажите получателя': 'Enter the recipient',
  'Укажите телефон': 'Enter a phone number',
  'Укажите телефон получателя': 'Enter the recipient phone number',
  'Указать бюджет': 'Set budget',
  'Условия': 'Requirements',
  'Хорошие фото: в полный рост, морда крупно, рядом с привычной переноской': 'Good photos show the full body, a close-up of the face and the usual carrier',
  'Частное лицо · имя нужно перевозчику для связи, телефон — для оперативных уведомлений': 'Individual · the carrier needs your name for contact; the phone is used for urgent updates',
  'Чем шире диапазон дат — тем больше откликов и ниже средняя цена': 'A wider date range usually brings more offers and a lower average price',
  'Что важно знать перевозчику': 'What the carrier should know',
  'Шаг 9': 'Step 9',
  'Я владелец животного и хочу его перевезти.': 'I own a pet and need transport.',
  'JPG, PNG · до 10 МБ · до 8 фото': 'JPG, PNG · up to 10 MB · up to 8 photos',
};
